var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel panel-default" }, [
    _c("div", { staticClass: "panel-heading" }, [
      _c("h4", { staticClass: "panel-title" }, [
        _c(
          "a",
          {
            staticClass: "accordion-toggle",
            attrs: {
              "data-toggle": "collapse",
              href: _vm.randomAcountHref(_vm.item.userId),
              "aria-expanded": "true"
            }
          },
          [
            _c("i", {
              staticClass: "ace-icon fa fa-angle-down bigger-110",
              attrs: {
                "data-icon-hide": "ace-icon fa fa-angle-down",
                "data-icon-show": "ace-icon fa fa-angle-right"
              }
            }),
            _vm._v("\n         アカウント\n      ")
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "panel-collapse collapse in",
        attrs: { id: _vm.randomAcountClass(_vm.item.userId) }
      },
      [
        _c("div", { staticClass: "panel-body" }, [
          _c(
            "div",
            { staticClass: "profile-user-info profile-user-info-striped" },
            [
              _c("div", { staticClass: "profile-info-row" }, [
                _c("div", { staticClass: "profile-info-name" }, [
                  _vm._v("ユーザーID")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "profile-info-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.item.userId))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "profile-info-row" }, [
                _c("div", { staticClass: "profile-info-name" }, [
                  _vm._v("ユーザー名/ふりがな")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "profile-info-value" }, [
                  _c("span", { staticClass: "editable" }, [
                    _vm._v(
                      _vm._s(_vm.item.name) + "/" + _vm._s(_vm.item.furigana)
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "profile-info-row" }, [
                _c("div", { staticClass: "profile-info-name" }, [
                  _vm._v("メールアドレス")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "profile-info-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.item.email))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "profile-info-row" }, [
                _c("div", { staticClass: "profile-info-name" }, [
                  _vm._v("組織管理権限")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "profile-info-value" }, [
                  _vm.item.isAdmin
                    ? _c("span", [_vm._v("管理者")])
                    : _c("span", [_vm._v("ユーザー")])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "profile-info-row" }, [
                _c("div", { staticClass: "profile-info-name" }, [
                  _vm._v("ゲート設定権限")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "profile-info-value" }, [
                  _vm.item.isPhoneAdmin
                    ? _c("span", [_vm._v("有効")])
                    : _c("span", [_vm._v("無効")])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "profile-info-row" }, [
                _c("div", { staticClass: "profile-info-name" }, [
                  _vm._v("鍵共有権限")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "profile-info-value" }, [
                  _vm.item.shareKeyBeValid
                    ? _c("span", [_vm._v("有効")])
                    : _c("span", [_vm._v("無効")])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "profile-info-row" }, [
                _c("div", { staticClass: "profile-info-name" }, [
                  _vm._v("ステータス")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "profile-info-value" }, [
                  _vm.item.isValid
                    ? _c("span", [_vm._v("有効")])
                    : _c("span", [_vm._v("無効")])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "profile-info-row" }, [
                _c("div", { staticClass: "profile-info-name" }, [
                  _vm._v("備考.1")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "profile-info-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.item.option1))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "profile-info-row" }, [
                _c("div", { staticClass: "profile-info-name" }, [
                  _vm._v("備考.2")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "profile-info-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.item.option2))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "profile-info-row" }, [
                _c("div", { staticClass: "profile-info-name" }, [
                  _vm._v("登録日 - 更新日")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "profile-info-value" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.converDateShort(_vm.item.registered)) +
                      " - " +
                      _vm._s(_vm.converDateShort(_vm.item.updated)) +
                      "\n          "
                  )
                ])
              ])
            ]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b114947", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b114947","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/UserDetailAccount.vue
// module id = null
// module chunks = 